/**
 * @license
 * Copyright (c) 2021 Handsoncode. All rights reserved.
 */
import { ArgumentTypes, FunctionPlugin } from './FunctionPlugin';
export class IsOddPlugin extends FunctionPlugin {
    isodd(ast, formulaAddress) {
        return this.runFunction(ast.args, formulaAddress, this.metadata('ISODD'), (val) => (val % 2 === 1));
    }
}
IsOddPlugin.implementedFunctions = {
    'ISODD': {
        method: 'isodd',
        parameters: [
            { argumentType: ArgumentTypes.NUMBER }
        ]
    },
};
